import { twMerge } from "tailwind-merge"
import { slides } from "@/constants/content"

type Props = {
  containerStyle?: React.CSSProperties
  currentSlideIndex: number
  imageStyle?: React.CSSProperties
  backgroundImageClass?: string
  containerClassName?: string
}

const ImagePane = ({
  containerStyle,
  currentSlideIndex,
  imageStyle,
  backgroundImageClass,
  containerClassName,
}: Props) => {
  return (
    <div
      className={twMerge(
        "animate-blur-in",
        "rounded-[10px] md:rounded-[15px] lg:rounded-[20px]",
        containerClassName,
      )}
      style={{
        opacity: 0,
        position: "relative",
        overflow: "hidden",
        isolation: "isolate", // Ensures isolation for blending
        transition: "background-color 1000ms",
        ...containerStyle,
      }}
    >
      {slides.map((slide, index) => (
        <div
          key={index}
          className={twMerge(
            "bg-[calc(100vw-40px)_auto] lg:bg-[1300px_auto]",
            backgroundImageClass,
          )}
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            height: "100%",
            width: "100%",
            backgroundImage: `url(${slide.backgroundImage})`,
            backgroundPosition: "top 50%",
            opacity: currentSlideIndex === index ? 1 : 0,
            mixBlendMode: "multiply",
            transition: "opacity 1000ms",
            ...imageStyle,
          }}
        />
      ))}
      {/* <div
        style={{
          position: "absolute",
          top: 0,
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(10deg, rgba(78,78,78,0.19), rgba(45,45,45,0.35)), url(https://grainy-gradients.vercel.app/noise.svg)",
          filter: "contrast(670%) brightness(1200%)",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: 0,
          width: "100%",
          height: "100%",
          background: slides[currentSlideIndex].accentColor,
          mixBlendMode: "multiply",
        }}
      /> */}
    </div>
  )
}

export default ImagePane
